import React from 'react';
import Calendar from "./Icons/Calendar";
import User from "./Icons/User";

function CardDetailFour(props) {
    const formatDateName = (data) => {
        if (data === null) {
            return ("N/A")
        } else {
            const date = new Date(data);
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            return `${date.getDate()} ${months[date.getMonth()]}, ${date.getFullYear()}`;
        }
    };
    return (
        <div>
            {props.data.slice(0, 3).map((item, index) => {
                    return (<>
                            <p className="metric-header padding-top">
                                {item.eE_ID}
                            </p>
                            <p className="metric-data">
                                <Calendar className="sidebar-icon small margin-right"
                                          color="var(--primary-100)"/>
                                {formatDateName(item.pay_Date)}
                            </p>
                        </>
                    )
                }
            )}
        </div>
    );
}

export default CardDetailFour;